import React, { useState } from "react"
import { Container } from "reactstrap"

const Organization = props => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <h4>Organization</h4>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Organization
